import { format, isValid, parse, parseISO } from "date-fns";

function parseEventDate(value: unknown): Date | null {
  if (typeof value !== "string" || !value.trim()) {
    return null;
  }
  const text = value.trim();
  // CMS responses use day-month-year; date inputs and writes use ISO dates.
  const date = /^\d{2}-\d{2}-\d{4}$/.test(text)
    ? parse(text, "dd-MM-yyyy", new Date(2000, 0, 1))
    : parseISO(text);
  return isValid(date) ? date : null;
}

export function eventDateLabel(value: unknown): string {
  return formatCmsDate(value, "MMM d, yyyy");
}

export function formatCmsDate(value: unknown, pattern: string): string {
  const date = parseEventDate(value);
  return date ? format(date, pattern) : "Date unavailable";
}

export function eventDateInput(value: unknown): string {
  const date = parseEventDate(value);
  return date ? format(date, "yyyy-MM-dd") : "";
}
